import { Section } from "@/model/CustomerSupport"
import { createContext, useContext } from "react"

type SectionContextType = {
  currentSection: Section
  currentSectionRootPath: string
  goBackToSectionRoot: () => void
}

export const SectionContext = createContext<SectionContextType | null>(null)

export const useSectionContext = () => {
  const context = useContext(SectionContext)
  if (!context) {
    throw new Error("useSectionContext must be used within SidebarLayout")
  }
  return context
}
